import * as React from "react";

import { LockClosed24Filled, LockClosed24Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const RbacApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "Rbac" */ "./RbacApp");
    return { default: namedExport.RbacApp };
});

export const Rbac: TeamAppConfig = {
    title: "RBAC",
    regularIcon: LockClosed24Regular,
    filledIcon: LockClosed24Filled,
    description: "Search and diagnose RBAC rules for role-based access control",
    team: "ServiceAuth",
    publicId: "Exchange\\ServiceAuth",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: ["RBAC", "ServiceAuth", "Access Control"],
    app: RbacApp,
    path: "/rbac"
};
